import { useQuery } from "@tanstack/react-query";
import axiosClient from "api/axiosClient";
import API_MAP from "constants/api";

export const useMonitorRoomListQuery = (props = {}) => {
    const { page, size, type, roomId, owner, start, end } = props;
    const queryKey = ["GET_MONITOR_ROOMS", page, size, type, roomId, owner, start, end]

    const fetchMonitorRoomList = () => {
        const params = {
            page,
            size,
            type,
            roomId,
            owner
        }

        if (start && end) {
            params.start = start
            params.end = end
        }

        return axiosClient.get(API_MAP.MONITOR.GET, {
            params
        });
    };

    return useQuery({
        queryKey,
        queryFn: fetchMonitorRoomList,
        keepPreviousData: true,
        staleTime: 5 * 60 * 1000,
        onSuccess: () => {},
        onError: () => {}
    });
}

export const useMonitorDetailRoomListQuery = (props = {}) => {
    const { roomId, role, username, refetchInterval } = props;
    const queryKey = ["GET_MONITOR_DETAIL_ROOMS", roomId, role, username]

    const fetchMonitorDetailRoomList = () => {
        const params = {
            conference_name: roomId,
            role
        }

        if (username) {
            params.username = username
        }

        return axiosClient.get(API_MAP.MONITOR.ENDPOINT_STATS, {
            params
        });
    };

    return useQuery({
        queryKey,
        queryFn: fetchMonitorDetailRoomList,
        keepPreviousData: true,
        refetchInterval,
        staleTime: 0,
        onSuccess: () => {},
        onError: () => {}
    });
}
